/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as emotion from "emotion";
import {COLORS} from "@res/colors";
import {BaseComponent, TS_Input} from "@intuitionrobotics/thunderstorm/frontend";
import {margin_rl_med} from "@styles/styles";
import {ICONS} from "@res/icons";
import * as React from "react";
import {generateHex} from "@intuitionrobotics/ts-common";


type SearchBarProps = {
    value?: string
    onValueChange: (value: string) => void
    placeholder?: string,
    color?: string,
    onClose?: () => void
}

export class SearchBar
    extends BaseComponent<SearchBarProps> {

    constructor(props: SearchBarProps) {
        super(props);
    }

    searchInputStyle = () => emotion.css(
        {
            flex: 1,
            width: 0, // chrome bug
            fontSize: '14px',
            fontFamily: 'Inter-Regular',
            fontStyle: !!this.props.value ? 'normal' : 'italic',
            outline: 'none',
            backgroundColor: this.props.color
        }
    );

    searchWrapperStyle = () => emotion.css(
        {
            minWidth: 100,
            maxWidth: 250,
            flex: 1,
            minHeight: 25,
            maxHeight: 25,
            borderBottom: 'solid',
            borderWidth: '1px',
            borderColor: !!this.props.value ? COLORS.primary_blue : COLORS.neutral_gray_1,
            justifyContent: 'space-between'
        }
    );

    renderClose = () => {
        return <div
            onClick={() => this.props.onClose && this.props.onClose()} style={{display: 'flex'}}>
            <div style={{paddingTop: '3px'}}>{ICONS.close(COLORS.neutral_gray_1, 10)}</div>
            <div style={{padding: '5px', color: COLORS.neutral_gray_1}}>|</div>
            <div style={{paddingTop: '6px'}}>{ICONS.search(COLORS.grays_dark, 16)}</div>
        </div>;
    };

    render() {
        return <div className={`ll_h_c clickable ${this.searchWrapperStyle()} ${margin_rl_med}`}>
            <TS_Input
                className={this.searchInputStyle()}
                name={generateHex(8)}
                placeholder={this.props.placeholder || 'Search by customer'}
                value={this.props.value}
                onChange={this.props.onValueChange}
                type={'text'}
                id={'search-all-patients'}
            />
            {!!this.props.value ? this.renderClose() : ICONS.search(COLORS.grays_dark, 16)}
        </div>;
    }
}
